import React, { useState, useEffect } from 'react';
import adminService from '../../services/adminService';
import styles from './AdminRevenuePage.module.scss';
import commonStyles from '../AdminOrdersPage/AdminOrdersPage.module.scss';
import { toast } from 'react-toastify';
import { IoStatsChart, IoPieChart } from 'react-icons/io5';

// --- IMPORT THƯ VIỆN BIỂU ĐỒ ---
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';

// Đăng ký các thành phần biểu đồ
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);

const AdminRevenuePage = () => {
  const [statsData, setStatsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState('date'); // date, month, year, category, product
  const [chartType, setChartType] = useState('bar'); // bar, pie

  useEffect(() => {
    loadStats();
  }, [filterType]);

  const loadStats = () => {
    setLoading(true);
    adminService.getRevenueStats(filterType)
      .then(res => {
        setStatsData(res.data);
        setLoading(false);
        
        // Tự động chọn loại biểu đồ phù hợp
        if (filterType === 'category') setChartType('pie');
        else setChartType('bar');
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  };

  // --- CẤU HÌNH DỮ LIỆU CHO BIỂU ĐỒ ---
  const chartDataConfig = {
    labels: statsData.map(item => item.label),
    datasets: [
      {
        label: 'Doanh Thu (VND)',
        data: statsData.map(item => item.value),
        backgroundColor: [
          'rgba(255, 99, 132, 0.6)',
          'rgba(54, 162, 235, 0.6)',
          'rgba(255, 206, 86, 0.6)',
          'rgba(75, 192, 192, 0.6)',
          'rgba(153, 102, 255, 0.6)',
          'rgba(255, 159, 64, 0.6)',
          '#5A3A29', // Màu nâu trầm
          '#C09758'  // Màu vàng trầm
        ],
        borderColor: 'rgba(255, 255, 255, 1)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: `Thống kê theo ${filterType.toUpperCase()}` },
    },
    scales: {
        y: {
            beginAtZero: true,
            ticks: {
                // Format tiền tệ trục Y
                callback: function(value) {
                    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(value);
                }
            }
        }
    }
  };

  return (
    <div className={commonStyles.adminPage}>
      <h1>Thống Kê Doanh Thu</h1>
      
      {/* THANH CÔNG CỤ */}
      <div className={styles.toolbar}>
         <div className={styles.filterGroup}>
            <label>Xem theo:</label>
            <select value={filterType} onChange={(e) => setFilterType(e.target.value)} className={styles.select}>
               <option value="date">Ngày (30 ngày qua)</option>
               <option value="month">Tháng (12 tháng qua)</option>
               <option value="year">Năm</option>
               <option value="category">Danh Mục</option>
               <option value="product">Top 10 Sản Phẩm</option>
            </select>
         </div>
         
         <div className={styles.totalBox}>
            <span>Tổng Doanh Thu (Trong báo cáo này):</span>
            <strong>
               {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(
                   statsData.reduce((acc, item) => acc + Number(item.value), 0)
               )}
            </strong>
         </div>
      </div>

      {/* KHUNG BIỂU ĐỒ */}
      <div className={styles.chartContainer}>
        {loading ? <p style={{textAlign:'center'}}>Đang tính toán...</p> : (
             statsData.length > 0 ? (
                chartType === 'pie' 
                ? <div style={{maxWidth: '500px', margin: '0 auto'}}><Pie data={chartDataConfig} /></div>
                : <Bar options={options} data={chartDataConfig} />
             ) : (
                 <p style={{textAlign:'center', padding: '50px'}}>Chưa có dữ liệu đơn hàng hoàn thành.</p>
             )
        )}
      </div>
    </div>
  );
};

export default AdminRevenuePage;